import { getAppcuesConfig } from '../network/ApiService'
import { useNetworkResponse } from '@activehub/common-components-spa-resource';
import { useEffect } from 'react';
import ScriptCache from '../components/micro-frontend/script-cache';
import { isProductionEnvironment, getCurrentEnvironment } from '../utils/environmentUtils';

export function useAppcues() {
    const appcuesConfigResponse = useNetworkResponse();
    const fetchAppcuesConfig = () => {
        if (!isProductionEnvironment()) {
            const currentEnv = getCurrentEnvironment();
            appcuesConfigResponse.dispatch({ 
                type: "SUCCESS", 
                payload: { ENV: currentEnv.toUpperCase(), SCRIPT_URL: null, ALLOWED_ORIGIN: [] } 
            });
            return () => {};
        }

        appcuesConfigResponse.dispatch({ type: "STARTED" });
        const subscription = getAppcuesConfig().subscribe(
            (response) => {
                let newResponse = {"ENV":"LOCAL","SCRIPT_URL":"//fast.appcues.com/92609.js","ALLOWED_ORIGIN":[window.location.hostname]};
                appcuesConfigResponse.dispatch({ type: "SUCCESS", payload: newResponse });
                const scriptCache = new ScriptCache();
                const scriptUrls = [newResponse.SCRIPT_URL]
                const isAllowed = newResponse.ALLOWED_ORIGIN.includes(window.location.hostname);
                if (!isAllowed) return;
                scriptCache.setScripts(scriptUrls)
                    .setContainerId("appcues-scipt")
                    .load(scriptUrls).then(() => {
                        console.log('Appcues success')
                    }).catch((error) => {
                        console.error('Appcues failed:', error);
                    });
            },
            (error) => {
                console.log('error fetching Appcues config');
                appcuesConfigResponse.dispatch({ 
                    type: "ERROR", 
                    payload: error 
                });
            }
        );
        
        return () => subscription.unsubscribe();
    }

    useEffect(() => {
        const cleanup = fetchAppcuesConfig();
        return cleanup;
    }, [])

    return {
        appcuesData: appcuesConfigResponse.data
    }
}  